import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { getSchoolRecordSettingApi, saveSchoolRecordSettingApi } from '../../../api/admin/schoolRecord'
import { swalAlert, swalErrorAlert } from '../../../utils/swal/swal'

const SchoolRecordSetting = () => {
    const { register, handleSubmit, reset } = useForm()

    useEffect(() => {
        getSchoolRecordSetting()

    }, [])

    const getSchoolRecordSetting = async () => {
        const response = await getSchoolRecordSettingApi()
        if (response?.data?.code === 200) {
            const settingData = response?.data?.resData
            reset(settingData)

        } else {
            reset(null)
        }

        return
    }

    const onSubmit = async (data) => {
        try {
            let requestData = data
            await saveSchoolRecordSettingApi(requestData)

            swalAlert('설정 저장 완료', '설정을 저장하였습니다.', 'success', '확인')

        }
        catch (error) {
            swalErrorAlert('설정 저장 에러', '설정을 저장하는 도중에 에러가 발생하였습니다.')

        }
        return
    }

    return (
        <form id='schoolRecordSettingForm' onSubmit={handleSubmit(onSubmit)}>
            <div>
                <div>
                    <div className='font-weight-bold'>생활기록부 열람 전역 설정</div>
                    <p className='pt-2 ps-1 text-black-50'>(*전역 설정 열람 권한보다 <span className='text-black'>학생 별로 설정된 열람 권한이 우선 적용</span>됩니다.)</p>
                </div>
                <div className='d-flex align-items-center pt-4 pb-2'>
                    <div className="form-check" style={{ minHeight: "auto" }}>
                        <input type="radio" id="isShowTrue" value={1} {...register('is_show')} className="form-check-input ms-0 mt-0 me-1" />
                        <label className="form-check-label" htmlFor="isShowTrue">열람 가능</label>
                    </div>
                    <div className="form-check" style={{ minHeight: "auto" }}>
                        <input type="radio" id="isShowFalse" value={0} {...register('is_show')} className="form-check-input ms-0 mt-0 me-1" />
                        <label className="form-check-label" htmlFor="isShowFalse">열람 불가능</label>
                    </div>
                </div>
            </div>
            <hr className='border-black' />

        </form>
    )
}

export default SchoolRecordSetting